/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { states } from '../states';

export const validatePhone = (s: string) => {
    return s && s.replace(/\D/g, '').length > 9;
};

export const capitalize = function (s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export function isEmptyObject(obj: {}) {
    return Object.keys(obj).length === 0;
}

export const stateOptions = states.map(state => ({
    value: state,
    label: state,
}));

const createRadioOptions = (opt: string) => ({
    label: opt,
    value: opt,
    id: opt,
});

export enum TINType {
    EIN = 'EIN',
    SSN = 'SSN',
}

export const getTaxIdPattern = (type?: string) => {
    if (type === TINType.SSN) return /^\d{3}-\d{2}-\d{4}$/;
    if (type === TINType.EIN) return /^\d{2}-\d{7}$/;
    return /$^/;
};

export const radioGroupTeamQuestions = [
    {
        name: 'systemInstalls',
        label: 'How many full system installs can your company complete in a week?',
        options: [
            '1-2 full system installs',
            '3-5 full system installs',
            '6+ full system installs',
        ].map(createRadioOptions),
    },
    {
        name: 'serviceCalls',
        label: 'How many service calls can your company complete in a week?',
        options: [
            '1-2 service calls',
            '3-5 service calls',
            '6+ service calls',
        ].map(createRadioOptions),
    },
    {
        name: 'masterTechs',
        label: 'How many master techs does your company have?',
        options: [
            '1-2 master techs',
            '3-5 master techs',
            '6+ master techs',
        ].map(createRadioOptions),
    },
    {
        name: 'employees',
        label: 'How many employees does your company have?',
        options: ['1-5 employees', '6-10 employees', '11+ employees'].map(
            createRadioOptions
        ),
    },
];
